import React, { Component } from "react";
import { withTranslation } from "react-multi-lang";
import { Popover, PopoverBody } from "reactstrap";
import $ from "jquery";
import { isMultitenant } from "./../../custom_functions/Constance.jsx";
import { capitalizeFirstLetter } from "./../../custom_functions/Functions.jsx";
import {
  // getprofilepic,
  updateprofilepic
} from "../../redux_store/actions/index";
import store from "./../../redux_store/store/index";

class Userdetail extends Component {
  _isMounted = false;
  constructor(props) {
    super(props);
    this.state = {
      imgsrc: "images/user_icon.svg",
    };
    this.ELNurl = window.appUrl.ELN;
  }

  componentDidMount() {
    this._isMounted = true;
    let usercode = -1;
    if (this.props.user !== null && this.props.user !== undefined) {
      usercode = this.props.user.usercode;
    }

    if (usercode !== undefined) {
      let imageurl = "";
      if (isMultitenant === 1) {
        imageurl = "" + this.ELNurl + "/User/Cloudprofile/" + usercode;
      } else {
        imageurl = "" + this.ELNurl + "/User/profile/" + usercode;
      }

      let profile = store.getState().profileimages.find(obj => obj.usercode === usercode);

      if (profile && !this.isBase64Url(profile.url)) {
        this.setState({ imgsrc: profile.url });
      }
      else {
        fetch(imageurl, {
          method: "GET",
          headers: new Headers({
            Authorization: $.session.get("Token"),
            "X-TenantID": $.session.get("tenantid"),
            Accept: "application/json",
            "Content-Type": "application/json",
            "Content-Encoding": "gzip",
          }),
        })
          .then((response) => {
            if (this._isMounted) {
              response.blob().then((blob) => {
                let url = window.URL.createObjectURL(blob);
                this.setState({ imgsrc: url });
                let profileindex = store.getState().profileimages.findIndex(obj => obj.usercode === usercode);
                if (profileindex > -1) {
                  store.getState().profileimages[profileindex].url = url;
                }
                else {
                  store.dispatch(updateprofilepic({ usercode: usercode, url: url }));
                }
              });
            }
          })
          .catch((error) => { });
        store.dispatch(updateprofilepic({
          usercode: usercode, url: "data:image/jpeg;base64,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"
        }));
      }

    } else {
      this.setState({ imgsrc: "./images/user_icon.svg" });
    }
  }
  isBase64Url(url) {
    return /^data:image\/[a-zA-Z]+;base64,/.test(url);
  }


  UNSAFE_componentWillReceiveProps(nextProps) {

    this._isMounted = true;
    let usercode = -1;
    if (this.props.user !== null && this.props.user !== undefined) {
      usercode = this.props.user.usercode;
    }

    if (usercode !== undefined) {
      let imageurl = "";
      if (isMultitenant === 1) {
        imageurl = "" + this.ELNurl + "/User/Cloudprofile/" + usercode;
      } else {
        imageurl = "" + this.ELNurl + "/User/profile/" + usercode;
      }

      let profile = store.getState().profileimages.find(obj => obj.usercode === usercode);
      if (profile && !this.isBase64Url(profile.url)) {
        this.setState({ imgsrc: profile.url });
      }
      else {
        fetch(imageurl, {
          method: "GET",
          headers: new Headers({
            Authorization: $.session.get("Token"),
            "X-TenantID": $.session.get("tenantid"),
            Accept: "application/json",
            "Content-Type": "application/json",
            "Content-Encoding": "gzip",
          }),
        })
          .then((response) => {
            if (this._isMounted) {
              response.blob().then((blob) => {
                let url = window.URL.createObjectURL(blob);
                this.setState({ imgsrc: url });
                store.dispatch(updateprofilepic({ usercode: usercode, url: url }));
              });
            }
          })
          .catch((error) => { });
      }
    } else {
      this.setState({ imgsrc: "./images/user_icon.svg" });
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  toggle = (targetName) => {
    if (!this.state[targetName]) {
      this.setState({
        ...this.state,
        [targetName]: {
          tooltipOpen: true,
        },
      });
    } else {
      this.setState({
        ...this.state,
        [targetName]: {
          tooltipOpen: !this.state[targetName].tooltipOpen,
        },
      });
    }
  };

  isToolTipOpen = (targetName) => {
    return this.state[targetName] ? this.state[targetName].tooltipOpen : false;
  };

  render() {
    let username = "";
    let usercode = "";
    let usergroup = "";
    let site = "";
    if (this.props.user !== null && this.props.user !== undefined) {
      username = this.props.user.username;
      usercode = this.props.user.usercode;
      if (
        this.props.user.lsusergroup !== null &&
        this.props.user.lsusergroup !== undefined
      ) {
        usergroup = this.props.user.lsusergroup.usergroupname;
      }

      if (
        this.props.user.lssitemaster !== null &&
        this.props.user.lssitemaster !== undefined
      ) {
        site = this.props.user.lssitemaster.sitename;
      }
    }

    return (
      <div className="userIcon">
        <img
          id={`user-${this.props.index}-${usercode}`}
          className="user-profile mr-2"
          src={this.state.imgsrc}
          alt="user"
          data-placement="top"
        />

        <Popover
          placement="left"
          trigger="hover"
          isOpen={this.isToolTipOpen(`user-${this.props.index}-${usercode}`)}
          target={`user-${this.props.index}-${usercode}`}
          toggle={() => this.toggle(`user-${this.props.index}-${usercode}`)}
        >
          <PopoverBody>
            <div className="row no-gutters align-center popover-minwidth userDetailsPopver">

              <div className="col-9">
                <div className="h6 text-break">{username}</div>
                <div>{usergroup}</div>
                <div>{site}</div>
              </div>
              <div className="col-3 text-center">
                <img
                  id={`user-${this.props.index}-${usercode}`}
                  className="user-profile-detail"
                  src={this.state.imgsrc}
                  alt="user"
                  data-placement="top"
                />
              </div>

              <div className="col-12">
                {isMultitenant === 1 &&
                  $.session.get("tenantdomain") !== undefined &&
                  $.session.get("tenantdomain") !== "" ? (
                  <div className="h6">Organisation</div>
                ) : (
                  ""
                )}
                {isMultitenant === 1 &&
                  $.session.get("tenantdomain") !== undefined &&
                  $.session.get("tenantdomain") !== "" ? (
                  <div>
                    {" "}
                    {capitalizeFirstLetter($.session.get("tenantdomain"))}
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
          </PopoverBody>
        </Popover>
      </div>
    );
  }
}
export default withTranslation(Userdetail);
